/**
 * Получает полный URL для изображения
 * Поддерживает как относительные пути от API, так и полные URL
 *
 * @param imagePath - Путь к изображению (например '/uploads/dishes/dish-123.jpg') или null
 * @returns Полный URL для изображения или null если путь не задан
 *
 * @example
 * getImageUrl('/uploads/dishes/dish-123.jpg')
 * // => 'http://localhost:3000/uploads/dishes/dish-123.jpg'
 *
 * getImageUrl(null)
 * // => null
 */
export const getImageUrl = (imagePath: string | null | undefined): string | null => {
  if (!imagePath) {
    return null;
  }

  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3000';

  // Если это уже полный URL, вернуть как есть
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }

  // Если это относительный путь, добавить базовый URL
  return `${apiUrl}${imagePath}`;
};
